import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { IRouteTrackModel } from '../../../../../src/app/core/models/route-track.model';
import * as toDoSelectors from '../../../features/todos/selectors';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.css']
})
export class BreadcrumbComponent implements OnInit {
  home: any;
  routes$: Observable<IRouteTrackModel[]>;
  constructor(
    private store: Store,
    private router: Router
  ) {
    this.routes$ = this.store.select(toDoSelectors.getRouteTracked);
  }

  ngOnInit(): void {
    this.home = { icon: 'home', tracker: '/admin-dashboard' };
  }

  itemClicked(route) {
    this.router.navigateByUrl(route.item.tracker);
  }
}
